/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Best_ValueInputs */

const en_landing_pricing_best_value = /** @type {(inputs: Landing_Pricing_Best_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best value`)
};

const zh_landing_pricing_best_value = /** @type {(inputs: Landing_Pricing_Best_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`超值`)
};

/**
* | output |
* | --- |
* | "Best value" |
*
* @param {Landing_Pricing_Best_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_best_value = /** @type {((inputs?: Landing_Pricing_Best_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Best_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_best_value(inputs)
	return zh_landing_pricing_best_value(inputs)
});
export { landing_pricing_best_value as "landing.pricing.best_value" }